import { jsx as _jsx } from "react/jsx-runtime";
import { List } from "react-admin";
import ListData from "$components/List/ListData";
import { ListActions } from "$components/List/ListActions";
import { ListEmpty } from "$components/List/ListEmpty";
export const ValueBitVotes = (props) => {
    return (_jsx(List, { empty: _jsx(ListEmpty, {}), actions: _jsx(ListActions, {}), ...props, children: _jsx(ListData, {}) }));
};
